import { motion } from "framer-motion";

export default function Reveal({
    children,
    delay = 0,
    y = 40,
    once = true,
    className = "",
    as = "div",
    duration = 1.1,
}) {
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-80px" }}
            transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </MotionTag>
    );
}
